export default {
  path: '/lvy-notary-service-privacy',
  component: () => import('./LVYNotaryServicePrivacy'),
  meta: {
    title: '隐私政策', // 供APP说明接入哪些第三方sdk的（中大公证服务）
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}